import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useAddSecurityEntryMutation } from '@/react-query/mutations/smartrade'

import { type SchemaType, schema } from './AddSecurityEntryForm.schema'

export interface AddSecurityEntryFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: React.ReactNode | ((form: UseFormReturn<SchemaType>) => React.ReactNode)
  onSubmit?: SubmitHandler<SchemaType>
}

export const AddSecurityEntryForm: React.FC<AddSecurityEntryFormProps> = ({
  children,
  onSubmit,
  defaultValues,
  ...props
}) => {
  const form = useFormWithSchema(
    {
      mode: 'all',
      ...props,
      defaultValues: {
        full_fee_bps: 54.0,
        end_drip_bps: 0.0,
        ...defaultValues,
      },
    },
    schema,
  )

  const addSecurityEntryMutation = useAddSecurityEntryMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (data, _e) => {
        await addSecurityEntryMutation.mutateAsync(data)
        form.reset()
      }),
  )

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
